// Registry of mounted forms by name. It lets redux thunks and connected
// components address a form by its name (change('form', field, value),
// submit('form'), ...), the way redux-form action creators did.

let forms = new Map();

export const registerForm = (name, entry) => {
  forms = new Map(forms).set(name, entry);
  return () => {
    if (forms.get(name) === entry) {
      const next = new Map(forms);
      next.delete(name);
      forms = next;
    }
  };
};

export const getRegisteredForm = name => forms.get(name);

// Form state of a mounted form that is not published to redux yet
// (the first render of the form children).
export const getRegisteredFormState = (name) => {
  const entry = forms.get(name);
  return entry ? entry.api.getState() : undefined;
};
